import Styled from 'vue3-styled-components';

const TableStyleWrapper = Styled.div`
  padding: 25px;
  background: #fff;
  border-radius: 10px
  table{
    tbody{
      td{
        .user-info{
          .user-name{
            font-size: 14px;
          }
        }
        span.status-text{
          font-size: 12px;
          padding: 0 12.41px;
          line-height: 1.9;
          font-weight: 500;
          border-radius: 12px;
          text-transform: capitalize;
          display: inline-block !important;
          background: #ddd;
          &.active{
            background-color: ${({theme}) => theme['success-color']}15;
            color: ${({theme}) => theme['success-color']};
          }
          &.inactive{
            background-color: ${({theme}) => theme['danger-color']}15;
            color: ${({theme}) => theme['warning-color']};
          }
        }
      }
    }
    .table-actions{
      min-width: 150px !important;
    }
  }
  .ant-table-pagination.ant-pagination{
    width: 100%;
    text-align: ${({theme}) => (!theme.rtl ? 'right' : 'left')};
    border-top: 1px solid ${({theme}) => theme['border-color-light']};
    margin-top: 0 !important;
    padding-top: 30px;
    @media only screen and (max-width: 767px){
      text-align: center;
    }
  }
  .contact-table{
    table{
      tr{
        th{
          &:first-child{
            ${({theme}) => (theme.rtl ? 'padding-right' : 'padding-left')}: 20px;
          }
          &:last-child{
            ${({theme}) => (theme.rtl ? 'padding-left' : 'padding-right')}: 20px;
          }
        }
      }
      .table-actions{
        button{
          width: auto;
          height: auto;
          padding: 0;
          background-color: transparent;
          color: #000000;
          &:hover{
            background-color: transparent;
            color: ${({theme}) => theme['primary-color']};
          }
          &.ant-btn-primary{
            &:hover{
              color: ${({theme}) => theme['primary-color']};
            }
          }
        }
      }
      tbody >tr.ant-table-row-selected >td{
        background-color: ${({theme}) => theme['primary-color']}10;
      }
    }
  }
`;

export {TableStyleWrapper};

